import styled from 'styled-components';

export const StyledUl = styled('ul')`
  list-style-type: disc;
  padding-left: ${({ theme }) => theme.x2}px;
`;

export const StyledLi = styled('li')`
  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.x2}px;
  }
`;
